var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgBasicInfo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3768_202547)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8536 10.1465L14.3536 8.64651C14.1585 8.45121 13.8416 8.45121 13.6465 8.64651L9 13.293V15.5001H11.2071L15.8535 10.8536C16.0488 10.6583 16.0489 10.3419 15.8536 10.1465ZM12.1465 13.1465L10.7928 14.5H10V13.7071L11.3535 12.3536L12.5 11.2071L13.293 12L12.1465 13.1465ZM14 11.293L13.207 10.5001L14 9.70711L14.7929 10.5001L14 11.293Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10V9H8V5.5H13V6.5H14V3C14 2.17285 13.3271 1.5 12.5 1.5H2.5C1.67285 1.5 1 2.17285 1 3V13C1 13.8271 1.67285 14.5 2.5 14.5H8V10H10ZM7 9H2V5.5H7V9ZM2.5 2.5H12.5C12.7758 2.5 13 2.7241 13 3V4.5H2V3C2 2.7241 2.22425 2.5 2.5 2.5ZM7 13.5H2.5C2.22425 13.5 2 13.2759 2 13V10H7V13.5Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3768_202547"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "currentColor"
  })))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgBasicInfo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/basic-info.2b8948992300a3e7d77c08f24e5482ae.svg";